import { hash64 } from './parse-values';
import { ParsedTxn, FingerprintedTxn } from '../money.model';

/**
 * Identity = hash of (account, date, amount, RAW description) plus an occurrence
 * counter scoped to this file.
 *
 * The counter is not defensive padding: the real Apple export contains two
 * identical $3.89 purchases at the same merchant on the same day. Without it,
 * one of them is silently deleted as a duplicate.
 *
 * The RAW description is hashed, never the normalized one — if identity depended
 * on normalization, any future tweak to the normalizer would change every
 * fingerprint and re-import the whole ledger as new.
 */
export function fingerprintTxns(txns: ParsedTxn[]): FingerprintedTxn[] {
  const seen = new Map<string, number>();
  return txns.map(t => {
    const base = hash64([t.accountId, t.date, String(t.amount), t.description].join('|'));
    const n = seen.get(base) ?? 0;
    seen.set(base, n + 1);
    return { ...t, fingerprint: `${base}_${n}` };
  });
}
